export const getCookieValue = (cookies: string, name: string): string | null => {
  const cookie = cookies.split(';').find((cookie) => {
    return cookie.trim().startsWith(`${name}=`)
  })
  const [, ...rest] = cookie?.split('=') ?? []
  return rest.join('=') || null
}
